<template>
    <form id="report-form" class="content-form form-horizontal" @submit.prevent="submit()" novalidate>
        <div class="form-group" :class="{'has-error': errors['name']}">
            <label for="name" class="col-sm-2 control-label">Nuevo Reporte</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="name" v-model="data.name" required placeholder="Ej: Certificado">
                <div class="help-block" v-for="e in errors['name']">{{e}}</div>
            </div>
        </div>
        <hr/>

        <div class="form-group">
            <div class="col-sm-9">
                <h4>Seleccionar campos</h4>
            </div>
            <!--
            <div class="col-sm-3 text-right">
                <button type="button" class="btn btn-primary">Agregar Campos</button>
            </div>
            -->
        </div>

        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group margin-right">
                        <label for="ids">ID</label>
                        <empty-select id="ids" class="d-block" multiple v-model="data.config.ids"></empty-select>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group margin-left">
                        <label for="names">Nombre de la Ficha / Aprende Sobre</label>
                        <empty-select id="names" class="d-block" multiple
                            :multiple-limit=5 v-model="data.config.names"></empty-select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group margin-right">
                        <label for="type">Tipo Contenido</label>
                        <page-type-select class="d-block" id="type" v-model="data.config.type"/>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group margin-left">
                        <label for="published">Publicado</label>
                        <published-select ref="published" id="published" class="d-block"
                                          v-model="data.config.published"></published-select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group margin-right">
                        <label for="ministry">Ministerio</label>
                        <ministry-select id="ministry" class="d-block" multiple :multiple-limit=5
                            v-model="data.config.ministries" :ministries="this.ministries   "></ministry-select>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group margin-left">
                        <label for="institution">Institución</label>
                        <institution-select :filter="data.config.ministries" id="institution" class="d-block"
                            multiple :multiple-limit=5  v-model="data.config.institutions" :institutions="this.institutions"></institution-select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group margin-right">
                        <label for="status">Estado</label>
                        <status-select id="status" class="d-block" v-model="data.config.status"></status-select>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group margin-left">
                        <label for="ga">¿Desea Incluir datos de Google Analytics?</label>
                        <el-select filterable clearable v-model="data.config.ga" class="d-block">
                            <el-option v-for="i in list" :key="i.value" :label="i.name" :value="i.value"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group">
            <div class="col-sm-12 text-right">
                <button type="reset" class="btn btn-danger" @click="clear()">Limpiar Campos</button>
                <button type="submit" class="btn btn-primary">Guardar Reporte</button>
            </div>
        </div>
    </form>
</template>
<style>
    #report-form #institution .el-select__tags {
        margin-top: -35px !important;
    }
</style>
<script>

    import ElSelect from 'element-ui/lib/select';
    import ElOption from 'element-ui/lib/option';
    import ElDatePicker from 'element-ui/lib/date-picker';
    import PageTypeSelect from './PageTypeSelect';
    import MinistrySelect from './MinistrySelect';
    import InstitutionSelect from './InstitutionSelect.vue';
    import StatusSelect from './StatusSelect';
    import PublishedSelect from './PublishedSelect';
    import EmptySelect from './EmptySelect';

    export default {
        components: {
            PageTypeSelect,
            ElSelect,
            ElOption,
            ElDatePicker,
            MinistrySelect,
            InstitutionSelect,
            StatusSelect,
            PublishedSelect,
            EmptySelect
        },
        data() {
            return {
                data: this.report || {
                    config: {
                        ids: [],
                        names: [],
                        ministries: [],
                        institutions: [],
                        type: '',
                        published: '',
                        status: '',
                        ga: ''
                    }
                },
                list: [
                    {
                        name: 'No',
                        value: '0'
                    },
                    {
                        name: 'Si',
                        value: '1'
                    }
                ],
                errors: {}
            }
        },
        props: ['report', 'edit', 'ministries', 'institutions'],
        methods: {
            submit() {
                axios({
                    url: this.edit ? `backend/reports/${this.report.id}` : 'backend/reports',
                    method: this.edit ? 'PUT' : 'POST',
                    data: this.data,
                }).then((response) => {
                    window.location.replace(response.data.redirect);
                }).catch((error) => {
                    this.errors = error.response.data.errors;
                });
            },
            clear() {
                this.data.config.ids = [];
                this.data.config.names = [];
                this.data.config.ministries = [];
                this.data.config.institutions = [];
                this.data.config.type = '';
                this.data.config.published = '';
                this.data.config.status = '';
                this.data.config.ga = '';
            }
        }
    }

</script>